import React, { createRef, forwardRef } from "react";
import Accordion from "@mui/material/Accordion";
// import MUIAccordianProps from "../../../interface";

const Accordian = forwardRef((props: any, ref: any) => {
  const accordianRef = ref || createRef<any>();

  return (
    <Accordion
      {...props}
      className={props.className}
      ref={accordianRef}
      disableGutters={true}
      classes={{ region: "h-full" }}
      sx={{
        boxShadow: "none",
        border: props.border ? props.border : "",
        borderRadius: props.borderRadius ? `${props.borderRadius} !important` : "",
        "&::before": {
          height: "0", //For removing extra top line
        },
        "&.MuiPaper-root": {
          height: "auto",
        },
        "& .MuiAccordionDetails-root": {
          height: "100%",
          width: "100%",
          padding: "0.5rem",
          transition: "opacity 0.3s ease, transform 0.3s ease",
          opacity: 0,
          transform: "translateY(-0.25rem)",
        },
        "& .MuiAccordionSummary-root": {
          width: "100%",
          padding: "0",
        },
        "& .MuiAccordionSummary-content": {
          width: "100%",
          margin: 0,
        },
        "& .MuiButtonBase-root.MuiListItemButton-root.Mui-selected": {
          backgroundColor: "#CAECFF",
        },
        "&.Mui-expanded .MuiAccordionDetails-root": {
          opacity: 1,
          transform: "translateY(0)",
        },
        ...props.sx,
      }}
    >
      {props.children}
    </Accordion>
  );
});
Accordian.displayName = "Accordian";
export default Accordian;
